import React from 'react';
import PerformanceMetricsD3 from '../../components/coach/charts/performance-metrics/PerformanceMetricsD3';

interface PerformanceMetricsD3PrototypePageProps {
  sessionId: string | null;
}

const PerformanceMetricsD3PrototypePage: React.FC<PerformanceMetricsD3PrototypePageProps> = ({
  sessionId,
}) => {
  return (
    <div className="h-[680px] sm:h-[700px] lg:h-[680px] xl:h-[540px]">
      <div className="h-full flex flex-col">
        <PerformanceMetricsD3 sessionId={sessionId || ''} />
      </div>
    </div>
  );
};

export default PerformanceMetricsD3PrototypePage;
